import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-vessel-nomination-modal',
    templateUrl: './vessel-nomination-modal.component.html',
    styleUrls: ['./vessel-nomination-modal.component.scss'],
    imports: [NgIf, FormsModule, ReactiveFormsModule]
})
export class VesselNominationModalComponent {
  vesselnominationform: UntypedFormGroup;
  showAcceptRemarks: boolean = false;
  showRejectRemarks: boolean = false;
  showErrRemarks: boolean = false;
  vesselData : any = [];
  enableLoader: boolean = true;

  @Input() shipmentId:any;
  @Input() vesselNominationStatus:any;
  @Output() refresh: EventEmitter<any> = new EventEmitter();
  disableRemarks = false;

  constructor(private formbuilder: UntypedFormBuilder,
    private customProductsService: CustomProductsService,
    public activeModal: NgbActiveModal,
    private toastService: ToastService,
    private router: Router
    ){}

  ngOnInit() {
    this.getVesselData();
    if(this.vesselNominationStatus == 'ACCEPTED' || this.vesselNominationStatus=='REJECTED'){
      this.disableRemarks = true;
    }else{
      this.disableRemarks = false;
    }
    this.vesselnominationform = this.formbuilder.group({
      Remarks: [{value:'', disabled: this.disableRemarks}, Validators.required],
    })

  }

  getVesselData(){
    this.enableLoader = true;
    this.customProductsService.getvesselNomination(this.shipmentId,this.vesselNominationStatus).subscribe(res=>{
      if(res){
        this.enableLoader = false;
        this.vesselData = res;

      }
    })
  }
  remarksfeild(event){
    if(event.target.value){
      this.showErrRemarks = false;
    }
  }
  acceptVessel(res){
    if(res == true){
      this.showAcceptRemarks = true;
    }else{
      this.showAcceptRemarks = false;
    }
  }

  confirmVessel(vesselstatus){
    this.showErrRemarks = false;
    const vesselRemarks = this.vesselnominationform.value.Remarks;
    this.customProductsService.acceptOrRejectNomination(this.shipmentId,vesselstatus,vesselRemarks).subscribe(resp=>{
      if(resp){
        this.activeModal.close();
        this.refresh.emit(resp); 
      }
    })
  }

  rejectVessel(vesselstatus){
    if(vesselstatus == 'REJECTED'){
      this.showRejectRemarks = true;
    }else{
      this.showRejectRemarks = false;
    } 

    if(this.vesselnominationform.value.Remarks != '' && this.vesselnominationform.value.Remarks != null){
      const vesselRemarks = this.vesselnominationform.value.Remarks;
      this.showErrRemarks = false;
      this.customProductsService.acceptOrRejectNomination(this.shipmentId,vesselstatus,vesselRemarks).subscribe(resp=>{
        if(resp){
          this.activeModal.close();
          this.refresh.emit(resp); 
        }
      })
    }else{
      this.showErrRemarks = true;
    }
  }

  cancel(){
    this.showAcceptRemarks = false;
    this.showRejectRemarks = false;
    this.showErrRemarks = false;
  }
  getnumber(number){
    if(number){
      return Number(number).toString();
    }
    else{
      return '0';
    }
    
  }
  getDate(date){
    if(date){
      var formateDate = new Date(date).getDate() + '/' + (new Date(date).getMonth() + 1) + '/' + new Date(date).getFullYear();
      return formateDate;
    }
    else{
      return '';
    }
  }
}
